import config from "../config";

export const AUTH_POPUP_MESSAGE_TYPE = "AUTH_POPUP_RESULT";

const normalizeNoTrailingSlash = (url) => (url || "").replace(/\/+$/, "");

const getFrontendBaseUrl = () => {
  const baseFromEnv = normalizeNoTrailingSlash(process.env.REACT_APP_BASEURL || "");
  if (baseFromEnv) {
    return baseFromEnv;
  }

  if (typeof window === "undefined") {
    return "";
  }

  const origin = window.location.origin;
  const mainDir = (process.env.REACT_APP_MAINDIR || "").replace(/^\/+|\/+$/g, "");
  return mainDir ? `${origin}/${mainDir}` : origin;
};

export const buildCallbackUrl = () =>
  `${getFrontendBaseUrl()}/auth/callback?popup=1`;

const getBackendBaseUrl = () => normalizeNoTrailingSlash(config.baseApiUrl || "");

export const isPopupCallbackRequest = (search = "") => {
  const params = new URLSearchParams(search || "");
  const popupFlag = String(params.get("popup") || "")
    .trim()
    .toLowerCase();
  return popupFlag === "1" || popupFlag === "true" || popupFlag === "yes";
};

export const getGoogleRedirectEndpoint = () => {
  const backendBaseUrl = getBackendBaseUrl();
  if (!backendBaseUrl) {
    return "";
  }

  const callbackUrl = buildCallbackUrl();
  return `${backendBaseUrl}/api/auth/google/redirect?redirect_url=${encodeURIComponent(
    callbackUrl
  )}`;
};

const openCenteredPopup = (url, title = "Google Login", width = 520, height = 680) => {
  if (typeof window === "undefined") {
    return null;
  }

  const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
  const dualScreenTop = window.screenTop ?? window.screenY ?? 0;
  const viewportWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    window.screen.width;
  const viewportHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    window.screen.height;
  const left = Math.max(0, dualScreenLeft + (viewportWidth - width) / 2);
  const top = Math.max(0, dualScreenTop + (viewportHeight - height) / 2);

  const features = [
    "popup=yes",
    `width=${Math.floor(width)}`,
    `height=${Math.floor(height)}`,
    `left=${Math.floor(left)}`,
    `top=${Math.floor(top)}`,
    "resizable=yes",
    "scrollbars=yes"
  ].join(",");

  return window.open(url, title, features);
};

export const redirectToGoogleLogin = () => {
  if (typeof window === "undefined") {
    return { ok: false, mode: "not_browser" };
  }

  const redirectEndpoint = getGoogleRedirectEndpoint();
  if (!redirectEndpoint) {
    return { ok: false, mode: "missing_endpoint" };
  }

  const popup = openCenteredPopup(redirectEndpoint);
  if (!popup || popup.closed || typeof popup.closed === "undefined") {
    return { ok: false, mode: "popup_blocked" };
  }

  popup.focus();
  return { ok: true, mode: "popup" };
};

export const handleUnauthorizedAndRelogin = () => {
  return redirectToGoogleLogin();
};

export const notifyPopupAuthResultAndClose = ({ success, reason = "" }) => {
  if (typeof window === "undefined") {
    return;
  }

  if (window.opener && !window.opener.closed) {
    window.opener.postMessage(
      {
        type: AUTH_POPUP_MESSAGE_TYPE,
        success: Boolean(success),
        reason: String(reason || "")
      },
      window.location.origin
    );
  }

  window.close();
};
